module.exports = __webpack_public_path__ + "img/img-2.714cfaa8.png";